export default __webpack_public_path__ + "static/media/cover.31c3ab1b.jpg";